module.exports = ['$scope', '$location', ($scope, $location) ->

  @goto = (data) ->
    $location.path '/profile/' + data

  @
]
